import { render, staticRenderFns } from "./MapIconSchool.vue?vue&type=template&id=8c99828e&scoped=true&"
import script from "./MapIconSchool.vue?vue&type=script&lang=js&"
export * from "./MapIconSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c99828e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c99828e')) {
      api.createRecord('8c99828e', component.options)
    } else {
      api.reload('8c99828e', component.options)
    }
    module.hot.accept("./MapIconSchool.vue?vue&type=template&id=8c99828e&scoped=true&", function () {
      api.rerender('8c99828e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconSchool.vue"
export default component.exports